export class SketchUtils {
  static getSketchpadBackground(item) {
    if (item.background) {
      return `url(${item.background})`;
    }
    return 'url(./assets/images/sketch-background.png)';
  }
}
